// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"02f3037e","436":"bcdfa6d7"}[chunkId] + ".chunk.js";
};